import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import { Plus } from 'lucide-react';
import type { ICreateFooterProps } from '../interfaces';

export const CreateFooter: React.FC<ICreateFooterProps> = ({
  isCreateDisabled,
  disabledTooltip,
  onCancel,
  onCreate,
}) => (
  <Box
    sx={{
      bgcolor: 'action.hover',
      borderTop: '1px solid',
      borderColor: 'divider',
      px: { xs: 3, md: 5 },
      py: 4,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: 2,
    }}
  >
    <Button
      variant="text"
      onClick={onCancel}
      sx={{
        px: 4,
        py: 1.5,
        borderRadius: 3,
        fontWeight: 700,
        textTransform: 'none',
        color: 'text.secondary',
        '&:hover': { bgcolor: 'action.selected' },
      }}
    >
      Cancel
    </Button>
    <Tooltip title={isCreateDisabled ? (disabledTooltip ?? '') : ''} arrow>
      <span>
        <Button
          variant="contained"
          disabled={isCreateDisabled}
          startIcon={<Plus size={18} />}
          onClick={onCreate}
          sx={{
            borderRadius: 3,
            px: 4,
            py: 1.5,
            fontWeight: 700,
            fontSize: '0.875rem',
            textTransform: 'none',
            boxShadow: 2,
          }}
        >
          Create Organization
        </Button>
      </span>
    </Tooltip>
  </Box>
);
